/** Рассчитывает отступ справа в процентах */
import { IUseLeftIndentPercent, IUseRightIndentPercent } from './types'

export const useRightIndentPercent: IUseRightIndentPercent = ({
  maxValue = 100,
  currentMaxValue,
}) => {
  const indent = maxValue - currentMaxValue
  const percent = (indent * 100) / maxValue

  return `${percent}%`
}

export const useLeftIndentPercent: IUseLeftIndentPercent = ({
  maxValue = 100,
  minValue = 0,
  currentMinValue = 0,
}) => {
  const percent = ((currentMinValue - minValue) * 100) / maxValue

  return `${percent}%`
}
